$(document).ready(function () {
    const btnAddLogo = $('#open-modal');
    let totalItems = 0;
    let payloadAddToCart;
    let selectedPosition = [];
    let uploadedImages = JSON.parse(localStorage.getItem('customer_uploadedImages')) || [];
    let restrictedCount = 0;
    const restrictionMap = {
        "Large Front": ["Left Breast", "Right Breast"],
        "Left Breast": ["Large Front"],
        "Right Breast": ["Large Front"],
        "Large Back": ["Nape of neck"],
        "Nape of neck": ["Large Back"]
    };
    let totalItemsInCart = btnAddLogo.attr('data-customize-count-in-cart');
    castleLoadSizes();
    $(document).on('change', 'input[name="options[Color]"]', function () {
        castleLoadSizes();
    });
    // Minus button action
    $('.castle-quantity-selector .qty-btn.minus').click(function () {
        var $input = $(this).siblings('.qty-input');
        var currentVal = parseInt($input.val());
        if (currentVal >= 1) {
            $input.val(currentVal - 1);
        }
        castleCheckAddLogo();
    });
    // Plus button action
    $('.castle-quantity-selector .qty-btn.plus').click(function () {
        var $input = $(this).siblings('.qty-input');
        var currentVal = parseInt($input.val());
        var maxVal = parseInt($input.attr('max'));
        if (currentVal < maxVal) {
            $input.val(currentVal + 1);
        }
        castleCheckAddLogo();
    });
    function getTotalParentQuantity(key = 'customized_logos_by_product') {
        const data = localStorage.getItem(key);
        if (!data) return 0;

        const parsedData = JSON.parse(data);
        return Object.values(parsedData)?.reduce((sum, item) => sum + (item?.parent?.quantity || 0), 0);
    }


    function castleCheckAddLogo() {
        const activeSizes = $('.castle-variant-selector-size tr.active');
        let currentSelectionQty = 0;
        payloadAddToCart = { items: [] };

        $.each(activeSizes, function () {
            const variantID = $(this).attr('data-variant-id');
            const variantQuantity = parseInt($(this).find('input').val()) || 0;

            currentSelectionQty += variantQuantity;

            if (variantQuantity > 0) {
                payloadAddToCart.items.push({
                    id: variantID,
                    quantity: variantQuantity,
                });
            }
        });
        totalItemsInCart = parseInt(totalItemsInCart) || 0;
        currentSelectionQty = parseInt(currentSelectionQty) || 0;
        totalItems = totalItemsInCart + currentSelectionQty;


        if (totalItems >= 5 && currentSelectionQty > 0) {
            btnAddLogo.prop('disabled', false);
        } else {
            btnAddLogo.prop('disabled', true);
        }
    }
    $(document).on('blur', '.qty-input', function () {
        const max = parseInt($(this).attr('max')); // Convert max to an integer
        const val = parseInt($(this).val()); // Convert input value to an integer
        if (val > max) {
            $(this).val(max); // Reset to the max value
            alert("You can't enter greater than available stocks.");
        }
        if ((totalItemsInCart >= 5 && val >= 1) || (totalItemsInCart < 5 && val >= 5)) {
            btnAddLogo.prop('disabled', false);
        } else {
            btnAddLogo.prop('disabled', true);
        }
    });
    function castleLoadSizes() {
        var selectedColor = $('input[name="options[Color]"]:checked').val();
        $('.current-size').html(' (' + selectedColor + ')');
        $('[data-color]').removeClass('active');
        $('[data-color="' + selectedColor + '"]').addClass('active');
        castleCheckAddLogo();
        $('.castle-quantity-selector input').val(0);
    }
    // Default add to Cart
    $(document).on('click', '#btn-add-to-cart', function () {
        handleAddToCart(this, payloadAddToCart, totalItems);
    });
    // Add to cart function
    function handleAddToCart(buttonEl, payloadAddToCart, totalItems) {
        if (totalItems > 0) {
            const $button = $(buttonEl);
            $button.prop('disabled', true).html('Please wait...');
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: payloadAddToCart,
                dataType: 'json',
                success: function () {
                    $button.prop('disabled', false).html('Add to Cart');
                    castleLoadSizes(); // Post-cart logic
                    window.location.href = '/cart';
                },
                error: function (error) {
                    console.error('Error adding to cart:', error);
                    $button.prop('disabled', false).html('Add to Cart');
                },
            });
        }
    }
    // Popup functions
    let currentStep = 0; // make this global so all functions use the same value
    let savedLogos = [];
    const totalSteps = 4;
    let customizeDataLocalStore = {}; // This will hold the mapping for localStorage

    let selectedApplicationType;
    function showStep(step) {
        // Clamp step value
        currentStep = Math.max(1, Math.min(step, totalSteps));
        // Show current step panel
        $('.step-panel').hide();
        $(`#step-${currentStep}`).show();
        // Update step header
        $('.stepper-container .step').each(function (index) {
            const $step = $(this);
            const stepIndex = index + 1;
            $step.removeClass('active completed');
            if (stepIndex < currentStep) {
                $step.addClass('completed');
                $step.find('.circle').html(`<svg width="9" height="6" viewBox="0 0 9 6" fill="none">
        <path d="M3.58811 5.75517C3.43059 5.75517 3.28095 5.69216 3.17069 5.5819L0.941809 3.35302C0.713408 3.12462 0.713408 2.74658 0.941809 2.51818C1.17021 2.28978 1.54825 2.28978 1.77665 2.51818L3.58811 4.32963L7.63632 0.281423C7.86472 0.0530224 8.24276 0.0530224 8.47116 0.281423C8.69957 0.509824 8.69957 0.887867 8.47116 1.11627L4.00553 5.5819C3.89527 5.69216 3.74563 5.75517 3.58811 5.75517Z" fill="#F8F8F8"/>
    </svg>`);
            } else if (stepIndex === currentStep) {
                $step.addClass('active');
                $step.find('.circle').empty();
            } else {
                $step.find('.circle').empty();
            }
        });
        // Footer button states
        $('#backBtn').toggle(currentStep !== 1);
        if (currentStep === 1) {
            $('.button__section').addClass('remove__backbtn');
        } else {
            $('.button__section').removeClass('remove__backbtn');
        }
        $('#nextBtn').toggle(currentStep < totalSteps);
        $('.add_more_confirm_btn').toggle(currentStep === totalSteps);
    }
    function goStep(direction) {
        showStep(currentStep + direction);
    }
    //  Custom Select Start
    $('.dropdown__toggle').on('click', function (e) {
        e.stopPropagation();
        let $currentMenu = $(this).next('.dropdown__menu');
        // Close all other open dropdown menus except the current one
        $('.dropdown__menu').not($currentMenu).removeClass('active');
        // Toggle the clicked dropdown menu
        $currentMenu.toggleClass('active');
        $(this).toggleClass('arrow-background__image');
        $('.dropdown__toggle').not(this).removeClass('arrow-background__image');
    });
    // Optional: handle item click
    $(document).on('click', '.dropdown__menu--item', function () {
        const selectedText = $(this).text();
        const selectedValue = $(this).attr('data-value');
        const selectedBgColor = $(this).attr('data-background');
        const selectedColor = $(this).attr('data-color');
        const $toggle = $(this).closest('.dropdown__container').find('.dropdown__toggle');

        $toggle.text(selectedText);
        $toggle.attr('data-value', selectedValue);
        $toggle.attr('data-background', selectedBgColor);
        $toggle.attr('data-color', selectedColor);

        $('.dropdown__menu').removeClass('active');
        $('.dropdown__toggle').removeClass('active arrow-background__image');

        $(this).siblings().removeClass('focused');
        $(this).addClass('focused');

        // 👇 Always called after selection
        updatePreview();
    });
    // Close dropdowns if clicking outside
    $(document).on('click', function () {
        $('.dropdown__menu').removeClass('active');
        $('.dropdown__toggle').removeClass('active');
        $('.dropdown__toggle').removeClass('arrow-background__image');
    });
    // Custom Select End
    // Tooltip Cose Start
    $(".tooltip").hover(function () {
        $('.tooltiptext').addClass('hover__tooltip');
    });
    // Tooltip Show on Click



    $('#close__tooltip').on('click', function () {
        $(this).closest(".tooltiptext").removeClass('hover__tooltip');
    });
    // Tooltip Cose End
    const $modal = $('#multi-step-modal');
    $('#open-modal').on('click', function () {
        $modal.addClass('display-flex');
        $('body').addClass('sticky-element');
        $('.section-header').addClass('no-z-index');
    });

    $('#close-modal').on('click', function () {
        $modal.removeClass('display-flex');
        $('body').removeClass('sticky-element');
        $('.section-header').removeClass('no-z-index');
    });
    // Outer click popup
    $(window).click(function (event) {
        if ($(event.target).is('#multi-step-modal')) {
            $('#multi-step-modal').removeClass('display-flex');
            $('body').removeClass('sticky-element');
        }
    });
    $('#backBtn').on('click', function () {
        const $modalContent = $('#multi-step-modal .modal-content .modal__body');
        $modalContent.scrollTop(0);
        $('#nextBtn').prop('disabled', false)
        if (currentStep > 1) {
            goStep(-1);
        }
        if (currentStep === 3) {
            const lastIndex = savedLogos.length - 1;
            const productVariantId = savedLogos[lastIndex]?.productVariantId || null;
            editLogo(productVariantId, "back"); // Go back to the last logo edit
        }
    });
    //Exisiting image selection
    $(document).on('click', '.existing_image-select', function () {
        const $modal = $('#image-modal');
        const $imageList = $('#image-selection-list');

        $imageList.empty();

        if (uploadedImages.length === 0) {
            $imageList.html('<p class="existing-image-empty">No uploaded images found.</p>');
        } else {
            uploadedImages.forEach((src, index) => {
                const fileExt = src.split('.').pop().toLowerCase();
                const fileName = src.split('/').pop();
                const isImage = ['jpg', 'jpeg', 'png'].includes(fileExt);

                const fileWrapper = $('<div class="existing-image-item"></div>');

                if (isImage) {
                    const imageContainer = $(`
      <div class="image-thumb-wrapper" data-src="${src}">
        <img src="${src}" alt="Image ${index + 1}" data-src="${src}" />
        <span class="eye-icon" data-src="${src}" title="View in new tab">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24">
            <path fill="#fff" d="M12 5c-7 0-10 7-10 7s3 7 10 7 10-7 10-7-3-7-10-7zm0 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10z"/>
            <path fill="#fff" d="M12 9a3 3 0 1 0 .001 6.001A3 3 0 0 0 12 9z"/>
          </svg>
        </span>
      </div>
    `);
                    fileWrapper.append(imageContainer);
                } else {
                    const docContainer = $(`
      <div class="doc-thumb-wrapper" data-src="${src}">
        <div class="doc-icon">
        &#x1F4C4;
        </div>
        <div class="doc-name">${fileName}</div>
        <span class="eye-icon" data-src="${src}" title="View in new tab">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24">
            <path fill="#fff" d="M12 5c-7 0-10 7-10 7s3 7 10 7 10-7 10-7-3-7-10-7zm0 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10z"/>
            <path fill="#fff" d="M12 9a3 3 0 1 0 .001 6.001A3 3 0 0 0 12 9z"/>
          </svg>
        </span>
      </div>
    `);
                    fileWrapper.append(docContainer);
                }

                $('#image-selection-list').append(fileWrapper);
            });
        }

        $modal.removeClass('display-none').addClass('display-flex');
    });

    // Close modal on × icon click
    $(document).on('click', '.existing-image-close', function () {
        $('#image-modal').removeClass('display-flex').addClass('display-none');
    });

    // Image selection
    $(document).on('click', '.existing-image-grid .image-thumb-wrapper, .existing-image-grid .doc-thumb-wrapper', function () {
        $('.existing-image-grid .image-thumb-wrapper, .existing-image-grid .doc-thumb-wrapper').removeClass('selected');
        $(this).addClass('selected');
        $('.existing-image-done-btn').prop('disabled', false);
        $('.existing-image-done-btn').attr("selected-img", $(this).data('src'));
        const selectedImage = $(this).data('src');
    });

    // On 'Done' button click
    $(document).on('click', '.existing-image-done-btn', function () {
        $('.existing-image-grid .image-thumb-wrapper, .existing-image-grid .doc-thumb-wrapper').removeClass('selected');
        const selectedImg = $(this).attr("selected-img");

        if (selectedImg) {
            $('#file').data('image-uploaded', true);
            const fileName = selectedImg.substring(selectedImg.lastIndexOf('/') + 1);
            $('.file__not-choose').html(
                'Uploaded file: <div class= "file__upload_link_parent"> <a class="file__link" href="' + selectedImg + '" target="_blank">' + fileName + '</a>  <span class="file__remove" ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M13.03 6.97a.75.75 0 0 1 0 1.06l-1.97 1.97 1.97 1.97a.75.75 0 1 1-1.06 1.06l-1.97-1.97-1.97 1.97a.75.75 0 0 1-1.06-1.06l1.97-1.97-1.97-1.97a.75.75 0 0 1 1.06-1.06l1.97 1.97 1.97-1.97a.75.75 0 0 1 1.06 0Z"></path><path fill-rule="evenodd" d="M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"></path></svg></span> </div>'
            );
            $('#image-modal').addClass('display-none');
            $('#image-modal').removeClass('display-flex');
            $('.file__not-choose').removeClass('display-none');
            $('.existing_image-select').addClass('display-none');
            $('#nextBtn').prop('disabled', false);
        } else {
            console.warn("No image selected.");
        }
    })
    $(document).on('click', '.eye-icon', function (e) {
        e.stopPropagation(); // prevent triggering other events
        const fileUrl = $(this).data('src');
        window.open(fileUrl, '_blank');
    });

    $('#nextBtn').on('click', function () {
        try {
            uploadedImages = JSON.parse(localStorage.getItem('customer_uploadedImages')) || [];
        } catch (e) {
            console.warn('Error saving image URL to localStorage:', e);
        }
        const $modalContent = $('#multi-step-modal .modal-content .modal__body');
        $modalContent.scrollTop(0);
        selectedApplicationType = '';
        // Step 1: Application selection always has a default, so no validation needed
        if (currentStep === 1) {
            selectedApplicationType = $('.option-card.selected').attr("value");
            if (uploadedImages.length == 0 || $('#file').data('image-uploaded')) {
                $('span.file__not-choose').removeClass('display-none');
                $('button.existing_image-select').addClass('display-none');
            } else {
                $('span.file__not-choose').addClass('display-none');
                $('button.existing_image-select').removeClass('display-none');
            }
        }

        // Step 2: Artwork validation
        if (currentStep === 2) {
            const artworkType = $('.artwork__btn.selected').attr("data-value") || 'N/A';
            let valid = true;
            let errorMsg = '';
            if (artworkType === 'Text') {
                const text = $('#customText').val().trim();
                if (!text) {
                    valid = false;
                    errorMsg = 'Please enter a text for your logo.';
                }
            } else if (artworkType === 'Image') {
                if (!$('#file').data('image-uploaded')) {
                    valid = false;
                    errorMsg = 'Please upload a logo image file.';
                }
            }
            if (!valid) {
                showToast(errorMsg, 'warning');
                return;
            }
        }
        // Step 3: Position selection validation
        if (currentStep === 3) {
            if ($('.position-card.selected').length === 0) {
                showToast('Please select a position for your logo.', 'warning');
                return;
            }
        }
        if (currentStep < totalSteps) {
            if (currentStep + 1 === 4) {
                selectedPosition.push({ id: $('.position-card.selected').data('position-id'), name: $('.position-card.selected').data('position-name') });
                saveLogoConfiguration(); // Call before step 4 is shown
                updateOverlayText()
                updateAddLogoButtonState(selectedPosition.length)
            }
            // Move to Step 2 or 3
            goStep(1);
            // If we're entering Step 3, filter cards
            if (currentStep + 1 === 3) {
                handleMethodFilter(selectedApplicationType);
            }
        }
    });
    $('.tooltip_close').on('click', function () {
        $(this).closest('.tooltip').find('.tooltiptext').css('visibility', 'hidden');
    });
    function handleMethodFilter(methodName) {
        var methodHandle = methodName.toLowerCase().replace(/\s+/g, '-'); // similar to Shopify's handleize
        $('.position-card').hide(); // Hide all
        $('.position-card[data-method="' + methodHandle + '"]').show(); // Show only matching ones
        updateOverlayText();
    }
    $('#addLogoBtn').on('click', function () {
        $(`#step-${currentStep}`).hide();
        currentStep = 1;
        showStep(currentStep);
        $('.position-card').removeClass('selected');
        $('#file').data('image-uploaded', false);
        $('.file__not-choose').text('No file chosen');
    });
    function showToast(message, type = 'success') {
        const $toast = $('#toast-message-content');
        $toast.removeClass('toast-success toast-error toast-warning').addClass(`toast-${type}`);
        $toast.text(message).fadeIn();
        // Hide after 3 seconds
        setTimeout(() => {
            $toast.fadeOut();
        }, 3000);
    }
    function saveLogoConfiguration() {
        const artworkType = $('.artwork__btn.selected').attr("data-value") || 'N/A';
        const note = $('#text-artwork textarea').val() || $('#image-artwork textarea').val() || '';
        const application = $('.option-card.selected').attr("value");
        const $positionCard = $('.position-card.selected');
        const positionName = $positionCard.data('print-position') || $positionCard.data('embroidery-position') || 'N/A';
        const positionImgUrl = $positionCard.find('img').attr('src') || 'No image found';
        const productVariantId = $positionCard.data('id') || '';
        const positionId = $positionCard.data('position-id') || '';
        const productTitle = $('#open-modal').data('product-title');
        const totalPositionCount = $('#open-modal').data('variant-count');
        const productPrice = $positionCard.data('print-variant-price-with-curr') || 'N/A';
        let uploadedLogoURL = $('.file__link').attr('href');
        const positionTitle = $positionCard.data('position-name');
        // --- Validation (redundant, but ensures direct calls are safe) ---
        if (artworkType === 'Text') {
            const text = $('#customText').val().trim();
            if (!text) {
                showToast('Please enter a text for your logo.', 'warning');
                return;
            }
        }
        else if (artworkType === 'Image') {
            if (!$('#file').data('image-uploaded')) {
                showToast('Please upload a logo image file.', 'warning');
                return;
            }
        }
        if (!$positionCard.length) {
            showToast('Please select a position for your logo.', 'warning');
            return;
        }
        // --- End Validation ---
        const logoData = {
            positionImgUrl,
            productTitle,
            uploadedLogoURL: uploadedLogoURL,
            uniqueLogoId: getRandomSixDigitNumber(),
            position: positionName,
            productVariantId,
            positionId,
            application,
            type: artworkType,
            note,
            text: null,
            font: null,
            color: null,
            bgColor: null,
            colorcode: null,
            price: productPrice,
            positionTitle: positionTitle
        };
        if (artworkType.toLowerCase().includes('text')) {
            logoData.text = $('#customText').val() || '';
            logoData.font = $('#fontSelect .dropdown__toggle').attr('data-value') || '';
            logoData.color = $('#colorSelect .dropdown__toggle').attr('data-color') || '';
            logoData.bgColor = $('#colorSelect .dropdown__toggle').attr('data-background') || '';
            logoData.colorcode = $('#colorSelect .dropdown__toggle').attr('data-value') || '';
        }
        savedLogos.push(logoData);
        if (uploadedLogoURL && !uploadedImages.includes(uploadedLogoURL)) {
            uploadedImages.push(uploadedLogoURL);
        }
        renderLogoSummary();
        // 🧹 Reset form and selections
        $('#text-artwork textarea').val('');
        $('#image-artwork textarea').val('');
        $('#customText').val('');
        $('#textPreview').text('Sample Text');
        $('#fontSelect .dropdown__toggle').attr('data-value', 'Standard');
        $('#fontSelect .dropdown__toggle').text('Standard');
        $('#colorSelect .dropdown__toggle').attr('data-color', 'White');
        $('#colorSelect .dropdown__toggle').text('White');
        $('#colorSelect .dropdown__toggle').attr('data-background', '#000000');
        $('#colorSelect .dropdown__toggle').attr('data-value', '#FFFFFF');
        // $('#fontSelect')[0].selectedIndex = 0;
        // $('#colorSelect')[0].selectedIndex = 0;
        updatePreview();
        updateAddLogoButtonState(selectedPosition.length);
        $('#file').data('image-uploaded', false);
        $('.file__not-choose').text('No file chosen');
    }
    function renderLogoSummary() {
        const $container = $('#logo-summary-container');
        $container.empty();
        if (savedLogos.length === 0) {
            $container.append('<p class="no-logo">No logos found.</p>');
            return;
        }
        $.each(savedLogos, function (index, logo) {
            const textDetails = logo.type === 'Text'
                ? `
    <p class="label__product">Text Line: <b>${logo.text}</b></p>
    <p class="label__product">Font Style: <b>${logo.font}</b></p>
    <p class="label__product">Font Color: <b>${logo.color}</b></p>
    `
                : `
    <p class="label__product">
        Uploaded Logo:
        <a href="${logo.uploadedLogoURL}" target="_blank" rel="noopener noreferrer">
            ${logo.uploadedLogoURL.substring(logo.uploadedLogoURL.lastIndexOf('/') + 1)}
        </a>
    </p>
    `;

            const $card = $(`
    <div class="logo__summary-card">
        <div class="remove__logo" data-product-id="${logo.productVariantId}"><svg width="12" height="13" viewBox="0 0 12 13" fill="none">
            <path d="M0.0253906 10.4082L4.33203 6.10156L0.0390625 1.80859L1.70703 0.140625L6 4.43359L10.2793 0.154297L11.9199 1.80859L7.6543 6.08789L11.9473 10.3809L10.2793 12.0488L5.98633 7.75586L1.67969 12.0625L0.0253906 10.4082Z" fill="#333333"></path>
        </svg></div>
        <div class="logo__details">
            <div class="logo__image">
                <img src="${logo.positionImgUrl}" />
            </div>
            <div class="logo__details-mobile">
                <div class="logo__image">
                    <img src="${logo.positionImgUrl}" />
                </div>
                <div class="product__details-mobile">
                    <h3 class="sub__heading-product">${logo.productTitle}</h3>
                    <p class="logo__id">Logo ID: ${logo.uniqueLogoId}</p>
                    <p class="label__price-mobile">${logo.price}</p>
                </div>
            </div>
            <div class="logo__info">
                <div class="logo__product-name">
                    <h3 class="sub__heading-product">${logo.productTitle}</h3>
                    <p class="logo__id">Logo ID: ${logo.uniqueLogoId}</p>
                </div>
                <div class="logo__desc-container">
                    <div class="logo__description-product common__width">
                        <p class="label__product">Position: <b>${logo.position}</b></p>
                        <p class="label__product">Application: <b>${logo.application}</b></p>
                        <p class="label__product">Type: <b>${logo.type}</b></p>
                    </div>
                    <div class="logo__text-details common__width">
                        ${textDetails}
                    </div>
                    <div class="logo__price">
                        <p class="label__product-price common__width">${logo.price}</p>
                    </div>
                    <div class="logo_actions common__width">
                        <button data-product-id="${logo.productVariantId}" class="logo__actions edit_logo">Edit</button>
                    </div>
                </div>
                ${logo.note ? `<p class="label__product common__width">Note: ${logo.note}</p>` : ''}
                <div class="logo__action-mobile">
                <button data-product-id="${logo.productVariantId}" class="logo__actions edit_logo">Edit</button>
                </div>
            </div>
        </div>
    </div>
    `);
            $container.append($card);
        });
    }
    $(document).on('click', '.option-card', function () {
        const $el = $(this);
        $el.closest('.options').find('.option-card').removeClass('selected');
        $el.addClass('selected');
    });
    currentStep = 1; // start from step 1
    showStep(currentStep);
    goStep(0); // initialize progress bar
    $('.artwork__btn').on('click', function () {
        $('#nextBtn').prop('disabled', false);
        const selectedValue = $(this).attr('data-value') || 'N/A';
        toggleArtworkOption(selectedValue);
    });

    function toggleArtworkOption(option) {
        const value = option.toLowerCase();

        $('.artwork__btn').removeClass('selected');
        $('.upload-image').removeClass('selected');
        $('.heading__description--text, .heading__description--image').removeClass('selected');

        if (value === 'text') {
            const $btn = $('.artwork__btn[data-value="Text"]');
            $btn.addClass('selected');
            $('#text-artwork').show();
            $('#image-artwork').hide();
            $('.heading__description--text').addClass('selected');
        } else {
            const $btn = $('.artwork__btn[data-value="Image"]');
            $btn.addClass('selected');
            $btn.closest('.upload-image').addClass('selected');
            $('#image-artwork').show();
            $('#text-artwork').hide();
            $('.heading__description--image').addClass('selected');
        }
    }


    // Update Preview
    function updatePreview() {
        let text = $('#customText').val(); // use let instead of const
        const font = $('#fontSelect .dropdown__toggle').attr('data-value') === "Standard" ? "normal" : $('#fontSelect .dropdown__toggle').attr('data-value');
        const color = $('#colorSelect .dropdown__toggle').attr('data-value');
        const bgColor = $('#colorSelect .dropdown__toggle').attr('data-background');
        if (!text.trim()) {
            text = 'Sample Text';
        }
        $('#textPreview').text(text).css({
            fontStyle: font,
            color: color,
            backgroundColor: bgColor
        });
    }
    // Delegated event handlers for preview updates
    $(document).on('input', '#customText', updatePreview);
    // Select Option Card
    $('#selectedOption .option-card').on('click', function () {
        $(this).siblings('.option-card').removeClass('selected');
        $(this).addClass('selected');
    });
    function updateOverlayText() {
        restrictedCount = 0;

        $('.position-card').each(function () {
            const $card = $(this);
            const id = $card.data('position-id');
            const name = $card.data('position-name');

            const isSelected = selectedPosition.some(pos => pos.id === id);

            // Step 1: If this position is directly selected
            if (isSelected) {
                $card.addClass('already-used');
                $card.find('.overlay-text')
                    .css('display', 'block')
                $card.removeClass('selected');
                return;
            }

            // Step 2: Check if this position is restricted
            let isRestricted = false;

            for (const selected of selectedPosition) {
                const restrictedNames = restrictionMap[selected.name] || [];
                if (restrictedNames.includes(name)) {
                    isRestricted = true;
                    break;
                }
            }


            if (isRestricted) {
                restrictedCount++;
                $card.addClass('already-used');
                $card.find('.overlay-text')
                    .css({
                        'display': 'block',
                        'background': '#000000'
                    })
                    .text('Not Applicable');
                $card.removeClass('selected');
            } else {
                $card.removeClass('already-used');
                $card.find('.overlay-text')
                    .css({ 'display': 'none', 'background': '#008000' })
                    .text('Already Selected'); // Clear previous text if any
            }
        });
    }



    // Select Position Card
    $('.position-card').on('click', function () {
        const $card = $(this);
        $('.position-card').removeClass('selected');
        $card.addClass('selected');
    });
    const usedPositions = new Set();
    let currentlySelected = null;
    $('.logo_position').on('click', function (el) {
        const $el = $(el.currentTarget);
        const id = $el.data('id');
        if (usedPositions.has(id)) return;
        if (currentlySelected) {
            currentlySelected.removeClass('selected');
        }
        currentlySelected = $el;
        $el.addClass('selected');
        usedPositions.add(id); // Store only the ID, not the DOM element
    })

    $(document).on('click', '.edit_logo', function (e) {
        const editId = $(this).data('product-id');
        editLogo(editId); // clickedbtn is optional here
    });
    $('#logo-summary-container').on('click', '.remove__logo', function (e) {
        const editId = $(this).data('product-id');
        const logo = savedLogos.find(logo => logo.productVariantId == editId);
        const editIdIndex = savedLogos.indexOf(logo);
        if (editIdIndex > -1) {
            savedLogos.splice(editIdIndex, 1);
            const positionremoveIndex = selectedPosition.findIndex(pos => pos.id === logo.positionId);
            if (positionremoveIndex > -1) {
                selectedPosition.splice(positionremoveIndex, 1); // Remove positionId object from selectedPosition
            }
            // Re-render the updated list
            uploadedImages = JSON.parse(localStorage.getItem('customer_uploadedImages')) || [];
            renderLogoSummary();
            updateOverlayText();
            updateAddLogoButtonState(selectedPosition.length);
        }
    });
    function editLogo(editId, clickedbtn) {
        const logo = savedLogos.find(logo => logo.productVariantId === editId);
        const editIdIndex = savedLogos.indexOf(logo);
        if (editIdIndex > -1) {
            savedLogos.splice(editIdIndex, 1); // Remove the logo from savedLogos
            const positionremoveIndex = selectedPosition.findIndex(pos => pos.id === logo.positionId);
            if (positionremoveIndex > -1) {
                selectedPosition.splice(positionremoveIndex, 1); // Remove positionId object from selectedPosition
            }
            // Populate fields with logo data
            if (logo.type.toLowerCase().includes('text')) {
                toggleArtworkOption(logo.type);
                $('#customText').val(logo.text || '');
                $('#fontSelect .dropdown__toggle').attr('data-value', logo.font || '');
                $('#fontSelect .dropdown__toggle').text(logo.font || 'Standard');
                $('#colorSelect .dropdown__toggle').attr('data-color', logo.color || 'White');
                $('#colorSelect .dropdown__toggle').text(logo.color || 'White');
                $('#colorSelect .dropdown__toggle').attr('data-background', logo.bgColor || '#000000');
                $('#colorSelect .dropdown__toggle').attr('data-value', logo.colorcode || '#FFFFFF');
                $('#text-artwork textarea').val(logo.note || ''); const positionremoveIndex = selectedPosition.findIndex(pos => pos.id === logo.positionId);
                if (positionremoveIndex > -1) {
                    selectedPosition.splice(positionremoveIndex, 1); // Remove positionId object from selectedPosition
                }
                updatePreview();
            } else {
                toggleArtworkOption(logo.type);
                $('#image-artwork textarea').val(logo.note || '');
                $('#file').data('image-uploaded', true);
                $('.file__not-choose').html(
                    'Uploaded file: <div class= "file__upload_link_parent"> <a class="file__link" href="' + logo.uploadedLogoURL + '" target="_blank">' + logo.uploadedLogoURL.substring(logo.uploadedLogoURL.lastIndexOf('/') + 1) + '</a>  <span class="file__remove" ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M13.03 6.97a.75.75 0 0 1 0 1.06l-1.97 1.97 1.97 1.97a.75.75 0 1 1-1.06 1.06l-1.97-1.97-1.97 1.97a.75.75 0 0 1-1.06-1.06l1.97-1.97-1.97-1.97a.75.75 0 0 1 1.06-1.06l1.97 1.97 1.97-1.97a.75.75 0 0 1 1.06 0Z"></path><path fill-rule="evenodd" d="M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"></path></svg></span> </div>'
                );
                $('.file__link').attr('href', logo.uploadedLogoURL || '');
            }

            $('.position-card').removeClass('selected');
            const $posCard = $(`.position-card[data-position-id='${logo.positionId}']`);
            if ($posCard.length) {
                $posCard.addClass('selected');
            }
            $(`#step-${currentStep}`).hide();
            if (clickedbtn == "back") {
                currentStep = 3;
            } else {
                currentStep = 1;
            }
            showStep(currentStep);
        } else {
            console.error('Logo not found for edit:', editId);
            return;
        }
        updateOverlayText();
    };
    // Image upload API Call
    const allowedExtensions = ['jpg', 'jpeg', 'png', 'eps', 'ai', 'pdf', 'psd'];
    const maxFileSize = 8 * 1024 * 1024; // 8MB
    const apiEndpoint = 'https://api.egclothing.co.uk';
    function getRandomSixDigitNumber() {
        return new Date().getTime();
    }
    $(document).on('change', '#file', function () {
        $('#file').data('image-uploaded', false);
        $('.file__not-choose').text('No file chosen');
        if (uploadedImages.length == 0 || $('#file').data('image-uploaded')) {
            $('span.file__not-choose').removeClass('display-none');
            $('button.existing_image-select').addClass('display-none');
        } else {
            $('span.file__not-choose').addClass('display-none');
            $('button.existing_image-select').removeClass('display-none');
        }
        $('#nextBtn').prop('disabled', true);
        const fileInput = this.files[0];
        if (!fileInput) {
            showToast('No file selected.', 'warning');
            return;
        }
        let fileName = fileInput.name;
        const fileSize = fileInput.size;
        const fileExtension = fileName.split('.').pop().toLowerCase();
        if (!allowedExtensions.includes(fileExtension)) {
            showToast('Invalid file type. Allowed types: JPG, PNG, EPS, AI, PDF, psd.', 'warning');
            $('#nextBtn').prop('disabled', false);
            return;
        }
        if (fileSize > maxFileSize) {
            showToast('File size exceeds the maximum limit of 8MB.', 'warning');
            $('#nextBtn').prop('disabled', false);
            return;
        }

        logoId = getRandomSixDigitNumber();
        $('#file').attr('data-logo-id', logoId);
        fileName = logoId;
        const formData = new FormData();
        formData.append('filename', fileName);
        formData.append('file', fileInput);
        $.ajax({
            url: apiEndpoint + '/api.php?t_=' + getRandomSixDigitNumber(),
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {
                try {
                    if (typeof response === 'string') response = JSON.parse(response);

                    if (response && response.status === 'success') {
                        showToast('File uploaded successfully!', 'success');

                        if (response.file_path) {
                            const imageURL = apiEndpoint + response.file_path;
                            const fileName = response.file_name || response.file_path.split('/').pop();

                            $('.file__not-choose').html(
                                'Uploaded file: <div class= "file__upload_link_parent"> <a class="file__link" href="' + imageURL + '" target="_blank">' + fileName + '</a>  <span class="file__remove" ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M13.03 6.97a.75.75 0 0 1 0 1.06l-1.97 1.97 1.97 1.97a.75.75 0 1 1-1.06 1.06l-1.97-1.97-1.97 1.97a.75.75 0 0 1-1.06-1.06l1.97-1.97-1.97-1.97a.75.75 0 0 1 1.06-1.06l1.97 1.97 1.97-1.97a.75.75 0 0 1 1.06 0Z"></path><path fill-rule="evenodd" d="M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"></path></svg></span> </div>'
                            );

                            $('#file').data('image-uploaded', true);
                            try {
                                const existing = JSON.parse(localStorage.getItem('customer_uploadedImages')) || [];
                                if (!existing.includes(imageURL)) {
                                    existing.push(imageURL);
                                    localStorage.setItem('customer_uploadedImages', JSON.stringify(existing));
                                }
                            } catch (e) {
                                console.warn('Error saving image URL to localStorage:', e);
                            }
                            $('#nextBtn').prop('disabled', false);
                            if (uploadedImages.length == 0 || $('#file').data('image-uploaded')) {
                                $('span.file__not-choose').removeClass('display-none');
                                $('button.existing_image-select').addClass('display-none');
                            } else {
                                $('span.file__not-choose').addClass('display-none');
                                $('button.existing_image-select').removeClass('display-none');
                            }
                        }
                    } else {
                        let msg = response?.message || 'File upload failed. Please try again.';
                        showToast(msg, 'error');
                        $('#file').val('');
                        $('#file').data('image-uploaded', false);
                        $('.file__not-choose').text('No file chosen');
                        $('#nextBtn').prop('disabled', false);
                    }
                } catch (err) {
                    showToast('Invalid response format.', 'error');
                    $('#nextBtn').prop('disabled', false);
                }
            },
            error: function (xhr) {
                const errorMessage = xhr.responseJSON?.message || 'An error occurred. Please try again later.';
                showToast(errorMessage, 'error');
                $('#file').val('');
                $('#file').data('image-uploaded', false);
                $('.file__not-choose').text('No file chosen');
                $('#nextBtn').prop('disabled', false);
                if (uploadedImages.length == 0 || $('#file').data('image-uploaded')) {
                    $('span.file__not-choose').removeClass('display-none');
                    $('button.existing_image-select').addClass('display-none');
                } else {
                    $('span.file__not-choose').addClass('display-none');
                    $('button.existing_image-select').removeClass('display-none');
                }
            }
        });

    });
    $(document).on('click', '.file__remove', function () {
        $('.existing-image-grid .image-thumb-wrapper, .existing-image-grid .doc-thumb-wrapper').removeClass('selected');
        $('.existing-image-done-btn').prop('disabled', true);
        $('#file').val('');
        $('#file').data('image-uploaded', false);
        $('#nextBtn').prop('disabled', true);
        $('.file__not-choose').html('No file chosen');
        uploadedImages = JSON.parse(localStorage.getItem('customer_uploadedImages')) || [];
        if (uploadedImages.length == 0 || $('#file').data('image-uploaded')) {
            $('span.file__not-choose').removeClass('display-none');
            $('button.existing_image-select').addClass('display-none');
        } else {
            $('span.file__not-choose').addClass('display-none');
            $('button.existing_image-select').removeClass('display-none');
        }
    });
    $("#confirmbtn").on("click", async function () {
        // Show loader
        $("#popup-loader").fadeIn();
        try {
            if (savedLogos.length > 0) {
                const CustomLogoPayLoad = await createCartPayload(savedLogos, payloadAddToCart);
                handleAddToCart('#addToCartBtn', CustomLogoPayLoad, CustomLogoPayLoad.items.length);
            }
        } finally {
            // Hide loader after add to cart completes (success or fail)
            $("#popup-loader").fadeOut();
        }
    });
    const localStorageKeyForProduct = 'customized_logos_by_product';
    const existingKeyForProduct = JSON.parse(localStorage.getItem(localStorageKeyForProduct) || '{}');
    // Create cart payload in the required structure
    async function createCartPayload(savedLogos, payloadAddToCart) {
        // Static product (new customer fee) config
        const localStorageKey = 'castle_customize_new_customer';
        const staticProductVariantId = 54881769226615; // Variant ID for the new customer fee
        const StaticProductsAdded = await isStaticProductExist(staticProductVariantId);
        const staticProductQuantity = 1;
        const formData = { items: [] };
        // Add all main products and logo line items
        payloadAddToCart.items.forEach(base => {
            const groupId = getRandomSixDigitNumber();
            const groupKey = `${base.id}:${groupId}`
            // Build main product properties
            const mainProductProperties = { "Customise Group ID": groupId };
            savedLogos.forEach((logo, idx) => {
                const n = idx + 1;
                const uniqueLogoId = logo.uniqueLogoId || getRandomSixDigitNumber();
                mainProductProperties[`Customise Logo ID #${n}`] = uniqueLogoId;
                mainProductProperties[`Customise Image URL #${n}`] = logo.uploadedLogoURL;
                mainProductProperties[`Customise Method #${n}`] = logo.application;
                mainProductProperties[`Customise Type #${n}`] = capitalizeFirstLetter(logo.type);
                mainProductProperties[`Customise Position Name #${n}`] = logo.position;
                mainProductProperties[`Customise Position Variant ID #${n}`] = logo.productVariantId;
                mainProductProperties[`Customise Text Line #${n}`] = logo.text || '';
                mainProductProperties[`Customise Font Style #${n}`] = logo.font || '';
                mainProductProperties[`Customise Font Colour #${n}`] = logo.color || '';
                mainProductProperties[`Customise Note #${n}`] = logo.note || '';
            });
            existingKeyForProduct[groupKey] = {
                parent: {
                    variantId: base.id,
                    quantity: base.quantity
                },
                logos: savedLogos
            };



            // Add main product
            formData.items.push({
                id: base.id,
                quantity: base.quantity,
                properties: mainProductProperties
            });
            // Add logo line items
            savedLogos.forEach((logo) => {
                formData.items.push({
                    id: logo.productVariantId,
                    quantity: base.quantity,
                    properties: {
                        "Customise Group ID": groupId,
                        "Customise Parent Variant ID": base.id,
                        "Customise Logo ID": logo.uniqueLogoId || getRandomSixDigitNumber(),
                        "Customise Type #": capitalizeFirstLetter(logo.type),
                        "Customise Text Line #": logo.text || '',
                        "Customise Font Style #": logo.font || '',
                        "Customise Font Colour #": logo.color || '',
                        "Customise Note #": logo.note || '',
                        "Customise Image URL #": logo.uploadedLogoURL,
                        "Customise Product Variant ID #": logo.productVariantId,
                    }
                });
            });
        });
        // Add static product if not present (only once per payload)
        let alreadyInPayload = formData.items.some(item => String(item.id) === String(staticProductVariantId));
        if (!StaticProductsAdded && !alreadyInPayload) {
            formData.items.push({
                id: staticProductVariantId,
                quantity: staticProductQuantity
            });
            localStorage.setItem(localStorageKey, 'yes');
        }
        localStorage.setItem(localStorageKeyForProduct, JSON.stringify(existingKeyForProduct));

        return formData;
    }
    function capitalizeFirstLetter(str) {
        return str ? str.charAt(0).toUpperCase() + str.slice(1) : '';
    }
    async function isStaticProductExist(staticProductVariantId) {
        try {
            const cart = await $.getJSON('/cart.js');
            return cart.items.some(item => String(item.id) === String(staticProductVariantId));
        } catch (err) {
            console.error("Error checking cart:", err);
            return false;
        }
    }
    // Utility to get total unique positions (across print and embroidery)
    function getTotalUniquePositions() {
        const positions = new Set();
        $('.position-card').each(function () {
            const posId = $(this).data('position-id');
            if (posId) positions.add(posId);
        });
        return positions.size;
    }
    // Update Add Logo button state based on positions
    function updateAddLogoButtonState(selectedCount) {
        const totalPositions = getTotalUniquePositions();
        const totalSelected = (selectedCount * 2) + restrictedCount;
        if (totalSelected >= (totalPositions * 2)) {
            $('#addLogoBtn').prop('disabled', true).text('All Positions Used');
        } else if (selectedCount === 0) {
            $('#addLogoBtn').prop('disabled', false).text('Add Logo');
        } else {
            $('#addLogoBtn').prop('disabled', false).text('Add Another Logo');
        }
        if (currentStep === 4 && selectedCount === 0) {
            $('#backBtn').hide();
            $('.button__section').addClass('remove__backbtn');
            $('#confirmbtn').prop('disabled', true);
        } else {
            $('#backBtn').toggle(currentStep !== 1);
            $('#confirmbtn').prop('disabled', false);
        }
    }
});